/* INVOICES */
export const GET_INVOICES = "GET_INVOICES";
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS";
export const GET_INVOICES_FAIL = "GET_INVOICES_FAIL";

export const GET_INVOICE_DETAIL = "GET_INVOICE_DETAIL";
export const GET_INVOICE_DETAIL_SUCCESS = "GET_INVOICE_DETAIL_SUCCESS";
export const GET_INVOICE_DETAIL_FAIL = "GET_INVOICE_DETAIL_FAIL";

export const SEND_INVOICE = "SEND_INVOICE";
export const SEND_INVOICE_SUCCESS = "SEND_INVOICE_SUCCESS";
export const SEND_INVOICE_FAIL = "SEND_INVOICE_FAIL";

export const GET_INVOICE_LIST = "GET_INVOICE_LIST";
export const GET_INVOICE_LIST_SUCCESS = "GET_INVOICE_LIST_SUCCESS";
export const GET_INVOICE_LIST_FAIL = "GET_INVOICE_LIST_FAIL";

export const GET_BULK_BILLINGS = "GET_BULK_BILLINGS";
export const GET_BULK_BILLINGS_SUCCESS = "GET_BULK_BILLINGS_SUCCESS";
export const GET_BULK_BILLINGS_FAIL = "GET_BULK_BILLINGS_FAIL";

export const SET_INVOICE_PAGINATION = "SET_INVOICE_PAGINATION";
